var _defs, _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 107 96",
    width: 107,
    height: 96,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-738-1579h1366v3181h-1366z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#7668f4}.b{fill:#343434}.c{fill:#ffe200}.d{fill:#ffb000}.e{fill:#e6e6e6}.f{opacity:.1}.g{opacity:.15;fill:#fff}.h{fill:#fcc397}.i{fill:#efb289}.j{fill:#fff}.k{fill:#ff003b}.l{opacity:.1;fill:#fff}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m79.4 12.3v30.9c0 2.3-1.9 4.2-4.2 4.2h-51.8c-2.2 0-4.1-1.9-4.1-4.2v-30.9c0-2.3 1.8-4.2 4.1-4.2h51.8c2.3 0 4.2 1.9 4.2 4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m19.3 34.3h60.1v7.1h-60.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m34.3 14.4v7.7c0 0.5-0.5 1-1.1 1h-7.7c-0.6 0-1-0.5-1-1v-7.7c0-0.6 0.4-1.1 1-1.1h7.7c0.6 0 1.1 0.5 1.1 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "d",
    d: "m33.2 23.4h-7.7c-0.7 0-1.3-0.6-1.3-1.3v-7.8c0-0.7 0.6-1.3 1.3-1.3h7.7c0.7 0 1.3 0.6 1.3 1.3v7.8c0 0.7-0.6 1.3-1.3 1.3zm-7.7-9.8c-0.4 0-0.8 0.3-0.8 0.8v7.7c0 0.4 0.4 0.8 0.8 0.8h7.7c0.5 0 0.8-0.4 0.8-0.8v-7.7c0-0.5-0.3-0.8-0.8-0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m28 17.8h-3.5v-0.5h3v-4h0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m34.3 17.8h-3.9v-4.5h0.5v4h3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m29.6 23.1h-0.5v-2.7h-4.6v-0.5h5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m54.2 16.1c0-0.5 0.4-0.9 0.9-0.9h16.5c0.5 0 0.9 0.4 0.9 0.9 0 0.5-0.4 0.9-0.9 0.9h-16.5c-0.5 0-0.9-0.4-0.9-0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m64 30c0-0.5 0.4-0.9 0.9-0.9h7.7c0.6 0 1 0.4 1 0.9 0 0.6-0.4 1-1 1h-7.7c-0.5 0-0.9-0.4-0.9-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m51 30c0-0.5 0.4-0.9 0.9-0.9h7.8c0.5 0 0.9 0.4 0.9 0.9 0 0.6-0.4 1-0.9 1h-7.8c-0.5 0-0.9-0.4-0.9-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m38 30c0-0.5 0.4-0.9 0.9-0.9h7.8c0.5 0 1 0.4 1 0.9 0 0.6-0.5 1-1 1h-7.8c-0.5 0-0.9-0.4-0.9-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m25.1 30c0-0.5 0.4-0.9 0.9-0.9h7.7c0.6 0 1 0.4 1 0.9 0 0.6-0.4 1-1 1h-7.7c-0.5 0-0.9-0.4-0.9-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m72.5 21.3c0 0.5-0.4 0.9-0.9 0.9h-25.8c-0.5 0-0.9-0.4-0.9-0.9 0-0.5 0.4-0.9 0.9-0.9h25.8c0.5 0 0.9 0.4 0.9 0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m75.2 10.2h-1.3v12.3c0 10.9-8.8 19.7-19.7 19.7h-32.8v1c0 1.2 0.9 2.1 2 2.1h51.8c1.2 0 2.1-0.9 2.1-2.1v-30.9c0-1.2-0.9-2.1-2.1-2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m79.4 12.3v3.5q-2.2 3.7-3.7 7.7c-0.7 1.9-1.5 4.1-3.4 4.7-2 0.6-4.2-0.7-6 0.3-2.2 1.3-1.5 4.9-3.2 6.8-2.5 3-8.3 0-11.1 2.8-1.1 1-1.4 2.7-2.2 3.9-1.2 1.7-3.3 2.6-5.4 2.8-2 0.3-4.1 0.1-6.2 0.3-2.1 0.2-4.2 0.8-5.6 2.3h-9.1c-2.3 0-4.2-1.9-4.2-4.2v-30.9c0-2.3 1.9-4.2 4.2-4.2h51.8c2.2 0 4.1 1.9 4.1 4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m64.7 8.1c-4.8 2.6-9.9 4.8-15.2 5.9-2.5 0.4-5.5 0.9-6.8 3.1-0.8 1.5-0.6 3.5-1.6 5-2.1 3-7.5 1.4-9.7 4.3-1.5 1.9-0.7 4.6-1.3 7-0.6 2.3-2.4 4.1-4.3 5.5-1.9 1.5-4 2.7-5.5 4.6q-0.4 0.5-0.7 1.2-0.3-0.7-0.3-1.5v-30.9c0-2.3 1.8-4.2 4.1-4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m16.1 59.5l8-4.4c6.3-3.5 13.7-4.1 20.4-1.7l7.1 2.5c2.1 0.8 4.3 1.1 6.6 1.1h6.3c4.5 0 7.8 4.3 6.6 8.7-0.8 3-3.5 5-6.6 5h-19.6 18.2c4.3 0 8.5-1.2 12.1-3.6l20.4-13.5c3.5-2.3 8.1-1.1 10.2 2.5 1.8 3.2 0.8 7.3-2.3 9.4l-36.2 24.4c-7.8 5.2-17.7 6.3-26.4 2.8l-2.4-0.9c-4.4-1.8-9.1-2.7-13.9-2.7h-8.5v-29.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m106.7 59.6c0 2.3-1.1 4.5-3.2 5.9l-36.2 24.4c-7.8 5.2-17.7 6.3-26.4 2.8l-2.6-1c-4.3-1.7-9-2.5-13.6-2.5h-8.6v-29.7l9.7-5.4v19c0 6.4 4.1 11.9 10.1 14.3q0 0 0.1 0l2.3 0.9c8.7 3.5 18.6 2.4 26.4-2.8l36.3-24.4c2-1.4 3.1-3.6 3.1-5.9q0-0.6-0.1-1.1 1.1 0.8 1.8 2c0.6 1.1 0.9 2.3 0.9 3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m66 70.5c1-0.1 1.9-0.3 2.8-0.5-0.7 0.5-1.4 1-2.3 1.3-0.6 0.2-1.3 0.3-2 0.3l-1.8 0.1h-3.5c-4.8 0-9.6-0.2-14.3-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m59.8 68.4l4.7-0.3c2-0.2 3.9-1.7 4.1-3.8 0.4-2.6-1.7-4.8-4.2-4.8h-4.8c-1.3 0-2.3 1-2.3 2.3v4.3c0 1.3 1.1 2.4 2.5 2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m106.7 59.6c0 0.7-0.1 1.5-0.4 2.2-3.8 1.9-7.5 4.2-10.9 6.9-1.7 1.3-3.6 2.8-5.7 2.9-2 0-3.8-1-5.7-0.8-3.6 0.3-5.6 4.5-9 5.5-1.8 0.5-3.9 0.1-5.6 0.9-2 1-2.8 3.5-4.3 5.3-1.9 2.2-4.8 3.1-7.5 4.2-4.1 1.8-7.8 4.4-10.8 7.6q-3-0.4-5.9-1.6l-2.3-0.9c-4.5-1.8-9.2-2.7-13.9-2.7h-8.5v-29.6l8-4.4c6.2-3.5 13.6-4.1 20.3-1.7l7.2 2.5c2.1 0.8 4.3 1.1 6.5 1.1h6.3c4.5 0 7.8 4.3 6.6 8.7-0.7 2.5-2.6 4.3-5 4.8 3.3-0.4 6.4-1.6 9.2-3.4l20.4-13.5c3.4-2.3 8.1-1.1 10.1 2.5 0.6 1.1 0.9 2.3 0.9 3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m70.5 60.6c-2.4 1-4.6 2.7-6.5 4.4-3.4 3-6.7 6.3-10.9 7.4-2.3 0.7-4.7 0.6-6.8 1.7-1.3 0.7-2.3 1.8-3.4 2.8-2.4 2.2-5.1 4.1-8.1 5.5-3.8 1.8-7.8 2.8-11.5 4.8-1 0.5-2 1.2-2.9 1.9h-4.3v-29.6l8-4.4c6.2-3.5 13.7-4.1 20.4-1.7l7.1 2.5c2.1 0.8 4.3 1.1 6.5 1.1h6.4c2.7 0 4.9 1.5 6 3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m0 55.7v37.3c0 1.5 1.2 2.7 2.7 2.7h15.9c1.5 0 2.7-1.2 2.7-2.7v-37.3c0-1.5-1.2-2.7-2.7-2.7h-15.9c-1.5 0-2.7 1.2-2.7 2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m14.2 85.6c0 1.9-1.6 3.5-3.6 3.5-1.9 0-3.5-1.6-3.5-3.5 0-2 1.6-3.5 3.5-3.5 2 0 3.6 1.5 3.6 3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m18.6 54.4h-0.8v24c0 7.5-6 13.6-13.5 13.6h-3v1c0 0.7 0.6 1.3 1.4 1.3h15.9c0.7 0 1.3-0.6 1.3-1.3v-37.3c0-0.7-0.6-1.3-1.3-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "m21.3 55.6c-0.6 1.8-0.9 3.6-0.9 5.5-0.1 2 0.1 4.2-1.2 5.8-0.6 0.9-1.6 1.5-2.4 2.3-1.4 1.4-1.9 3.6-1.4 5.5 0.5 2.2 2.4 4.3 1.7 6.5-0.4 1.2-1.5 2-2 3.1-1 2.3 0.8 4.8 1.1 7.4 0.1 1.4-0.3 2.8-1 4h-12.5c-1.5 0-2.7-1.2-2.7-2.7v-37.3c0-1.5 1.2-2.7 2.7-2.7h15.9c1.4 0 2.6 1.1 2.7 2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "m8.4 81.2c1 3.9-0.5 8.2-3.1 11.3-0.9 1.2-2 2.2-3.1 3.1-1.3-0.2-2.2-1.3-2.2-2.6v-37.3c0-1.5 1.2-2.7 2.7-2.7h6.7c-0.9 2.2-1.3 4.7-1.1 7 0.2 2.3 0.8 4.5-0.1 6.6-0.6 1.5-1.9 2.6-2.4 4.1-0.7 1.7-0.3 3.7 0.4 5.4 0.8 1.7 1.7 3.3 2.2 5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m95.7 10h2v11.2c0 0.4 0.4 0.8 0.8 0.8h3.9c0.5 0 0.8-0.4 0.8-0.8v-11.2h2.1c0.6 0 1-0.7 0.7-1.3l-4.8-8.3c-0.3-0.5-1.1-0.5-1.5 0l-4.7 8.3c-0.4 0.6 0 1.3 0.7 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m83.2 28.7h2v11.2c0 0.5 0.4 0.8 0.9 0.8h3.8c0.5 0 0.9-0.3 0.9-0.8v-11.2h2c0.6 0 1.1-0.7 0.7-1.2l-4.8-8.3c-0.3-0.6-1.1-0.6-1.4 0l-4.8 8.3c-0.3 0.5 0.1 1.2 0.7 1.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg8);
export default __webpack_public_path__ + "static/media/8.ed9a208542adc6e5b260fc5166dd59b3.svg";
export { ForwardRef as ReactComponent };